// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__23Ewa","title":"Card_title__3vzIT","year":"Card_year__1qkH0","user":"Card_user__2_etL","toolBox":"Card_toolBox__1oM6H"};